import makeReducerFor from "./_genericDbReducer";
import { createSelector } from "reselect";
import { getFlowItemsForSelectedFlow } from "./flowItems";
import type { FlowScriptResult, FlowItem } from "../types/flowTypes";

const myGenericReducer = makeReducerFor("FLOW_SCRIPT_RESULT", "FlowScriptResultId");
import subItemReducer from "./_genericFlowSubItemReducer";

const myReducer = (state = {}, action) => subItemReducer(myGenericReducer(state, action), action);
export default myReducer;

///////// SELECTORS /////////////

export const getFlowScriptResultsArray = createSelector(
    state => state.flowScriptResults.byId,
    (FlowScriptResultsById: {| [number]: FlowScriptResult |}): Array<FlowScriptResult> => {
        const r: Array<FlowScriptResult> = Object.values(FlowScriptResultsById);
        return r;
    }
);

export type FlowScriptResultsByItemId = {
    [number]: Array<FlowScriptResult>,
};
// eslint-disable-line
export const getFlowScriptResultsByFlowItemId = createSelector(
    state => getFlowScriptResultsArray(state),
    (FlowScriptResults: Array<FlowScriptResult>): FlowScriptResultsByItemId =>
        FlowScriptResults.reduce((acc, row) => {
            if (!acc[row.FlowItemId]) {
                acc[row.FlowItemId] = [];
            }
            acc[row.FlowItemId].push(row);
            return acc;
        }, {})
);

export const getFlowScriptResultsForSelectedFlow = createSelector(
    state => state.selected.flow,
    state => getFlowItemsForSelectedFlow(state),
    state => getFlowScriptResultsByFlowItemId(state),
    (
        selectedFlow: number,
        flowItems: Array<FlowItem>,
        flowScriptResultsByItemId: FlowScriptResultsByItemId
    ): Array<FlowScriptResult> => {
        const itemIds = flowItems.map(fi => fi.FlowItemId);
        const result = [];
        for (const itemId of itemIds) {
            const script = flowScriptResultsByItemId[itemId];
            if (script != null) {
                result.concat(script);
            }
        }
        return result;
    }
);

export const getFlowScriptResultsByFlowItemIdFromProps = createSelector(
    state => getFlowScriptResultsByFlowItemId(state),
    state => state.selected.flowItem,
    (flowScriptResultsByFlowItemId: FlowScriptResultsByItemId, flowItemId: number): Array<FlowScriptResult> =>
        flowScriptResultsByFlowItemId[flowItemId]
);
